export const ACTIONS = {
	ADD_CHANGES: 'ADD_CHANGES' as const,
	REMOVE_CHANGES: 'REMOVE_CHANGES' as const,
	RESET: 'RESET' as const,
	SET_COUNT: 'SET_COUNT' as const,
};
